import src from "IMAGE";
export default { src, width: 357, height: 80, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AHs/TGhXS05JR0dHPFNTU0VNTU1BVlZWRlBQUENRUVFDAFVMTkdKSEk9KCgoISIiIhweHh4YPDw8K09PTzlEREQwW5wQrMkss0kAAAAASUVORK5CYII="};
